// Utility for snapping dates to the nearest available chart date

/**
 * Snap a given date string to the nearest available chart date.
 * @param {string} dateStr - The date to snap (YYYY-MM-DD or YYYY-MM-DDTHH:mm:ss)
 * @param {string[]} chartDates - Array of chart date strings (YYYY-MM-DD or with time)
 * @returns {string} The chart date closest to dateStr
 */
export function normalizeDate(dateStr) {
  if (!dateStr) {
    return null;
  }
  return dateStr.split('T')[0];
}

export function snapToNearestChartDate(dateStr, chartDates) {
  if (!chartDates || chartDates.length === 0) return dateStr;
  const target = new Date(dateStr.split('T')[0]);
  let minDiff = Infinity;
  let snapped = chartDates[0];
  for (const d of chartDates) {
    const chartDate = new Date(d.split('T')[0]);
    const diff = Math.abs(chartDate - target);
    if (diff < minDiff) {
      minDiff = diff;
      snapped = d;
    }
  }
  return snapped;
}
